<template>
  <el-dialog
    :visible="true"
    width="350px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div id="printOrder">
      <table>
        <tr>
          <td class="textname">单号:</td>
          <td class="textbig">{{ this.orderData.orderid }}</td>
        </tr>
        <tr>
          <td class="textname">订单名称:</td>
          <td class="textbig">{{ this.orderData.orderName }}</td>
        </tr>
        <tr>
          <td class="textname">金额:</td>
          <td class="textbig">{{ this.orderData.totalPrice }}</td>
        </tr>
        <tr>
          <td class="textname">&nbsp;</td>
          <td class="textbig">
            <span style="font-size:28px">□</span>已完成
            <span style="font-size:28px">□</span>退单
          </td>
        </tr>
        <tr>
          <td class="textname">用户:</td>
          <td class="textbig">{{ this.orderData.username }}</td>
        </tr>
        <tr>
          <td class="textname">门店:</td>
          <td class="textbig">{{ this.shopName }}</td>
        </tr>
        <tr>
          <td class="textname">下单时间:</td>
          <td class="textbig">{{ this.orderData.orderDate }}</td>
        </tr>
      </table>

      <!-- <div class="d1">
        <span class="textname">单号:</span
        ><span class="textbig">{{ this.orderData.orderid }}</span>
      </div>
      <div class="d1">
        <span class="textname">订单名称:</span
        ><span class="textbig">{{ this.orderData.orderName }}</span>
      </div>
      <div class="d1">
        <span class="textname">金额： </span
        ><span class="textbig">{{ this.orderData.totalPrice }}元</span>
      </div>

      <div class="d1">
        <span class="textname"></span>
        <span class="textbig">
          <span style="font-size:28px">□</span>已完成</span
        >
        <span class="textbig" style="margin-left:30px">
          <span style="font-size:28px">□</span>退单</span
        >
      </div>
      <div class="d1" style="margin-top:10px;">
        <span class="textname">用户： </span
        ><span class="textbig">{{ this.orderData.username }}</span>
      </div>
      <div class="d1">
        <span class="textname">门店： </span><span>{{ this.shopName }}</span>
      </div>
      <div class="d1">
        <span class="textname">下单时间： </span
        ><span>{{ this.orderData.orderDate }}</span>
      </div> -->
    </div>
    <el-button type="primary" v-print="'#printOrder'">打印</el-button>
  </el-dialog>
</template>

<script>
export default {
  props: ["orderData", "shopName"],
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
    }
  },
  mounted() {
    console.log(this.orderData);
  }
};
</script>

<style lang="less" scoped>
.d1 {
  padding: 0px;
}
.textname {
  font-size: 14px;
  padding-bottom: 8px;
  width: 70px;
  // background: red;
  // display: -moz-inline-box;
  display: inline-block;
  margin: 10px 0px;
}
.textbig {
  padding-bottom: 8px;
  font-size: 16px;
  font-weight: bold;
}
</style>
